// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.notepad.widget .main.content {
  display: flex;
}

.notepad.widget .main.content > div {
  flex-direction: column;
}

.notepad.widget .main.content .notepad-container textarea {
  height: 100vh;
  display: block;
  resize: none;
}
`, "",{"version":3,"sources":["webpack://./src/routes/Home/widgets/Notepad/style.css"],"names":[],"mappings":"AAAA;EACE,aAAa;AACf;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,cAAc;EACd,YAAY;AACd","sourcesContent":[".notepad.widget .main.content {\n  display: flex;\n}\n\n.notepad.widget .main.content > div {\n  flex-direction: column;\n}\n\n.notepad.widget .main.content .notepad-container textarea {\n  height: 100vh;\n  display: block;\n  resize: none;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
